const EURO_FORMATTER = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCents(cents: number): string {
  if (!Number.isSafeInteger(cents)) throw new RangeError('Geldwerte müssen sichere Cent-Ganzzahlen sein.');
  return EURO_FORMATTER.format(cents / 100);
}

export function formatEuro(cents: number): string {
  return `${formatCents(cents)} €`;
}

export function sanitizePlayerName(value: unknown, fallback = 'Duelist'): string {
  const normalized = (typeof value === 'string' ? value : '').replace(/\s+/g, ' ').trim().slice(0, 20);
  return normalized || fallback;
}
